import { render, staticRenderFns } from "./Fdic.vue?vue&type=template&id=9f582f20&scoped=true"
import script from "./Fdic.vue?vue&type=script&lang=ts"
export * from "./Fdic.vue?vue&type=script&lang=ts"
import style0 from "./Fdic.vue?vue&type=style&index=0&id=9f582f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f582f20",
  null
  
)

export default component.exports